export const shapeName = 'TSAgentMessageInput';
export const unknownInputSchema = {
    title: 'TSAgentMessageUnknownInput',
    type: 'object',
    properties: {
        type: {
            const: 'unknown'
        },
        data: {}
    },
    required: ['type', 'data'],
    additionalProperties: false
};
export const stringInputSchema = {
    title: 'TSAgentMessageStringInput',
    type: 'object',
    properties: {
        type: {
            const: 'string'
        },
        content: {
            type: 'string'
        }
    },
    required: ['type', 'content'],
    additionalProperties: false
};
export const schema = {
    title: shapeName,
    description: 'The input schema for agent messages.',
    discriminator: {
        propertyName: 'type'
    },
    oneOf: [unknownInputSchema, stringInputSchema]
};
export const shapeSchema = {
    ...schema,
    oneOf: [{ '@ref': unknownInputSchema.title }, { '@ref': stringInputSchema.title }]
};
